
import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { User } from 'firebase/auth';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

interface GstCalculatorProps {
  currentUser: User | null;
}

const GstCalculator: React.FC<GstCalculatorProps> = ({ currentUser }) => {
  const [amount, setAmount] = useState<number | string>('');
  const [rate, setRate] = useState<number | string>('18');
  const [gst, setGst] = useState<number | null>(null);

  const calculateGst = () => {
    const principalAmount = Number(amount);
    const gstRate = Number(rate);

    if (principalAmount > 0 && gstRate > 0) {
      const gstValue = (principalAmount * gstRate) / 100;
      setGst(gstValue);
    } else {
      setGst(null);
    }
  };

  return (
    <div>
      <h3 className="mb-3">GST Calculator</h3>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Amount</Form.Label>
          <Form.Control
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>GST Rate (%)</Form.Label>
          <Form.Control
            type="number"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            placeholder="Enter GST rate"
          />
        </Form.Group>
        <Button variant="primary" onClick={calculateGst}>
          Calculate GST
        </Button>
        {currentUser && gst !== null && (
          <Button variant="secondary" onClick={async () => {
            try {
              await addDoc(collection(db, `users/${currentUser.uid}/savedCalculations`), {
                calculatorType: 'gst',
                amount,
                rate,
                gst,
                totalAmount: Number(amount) + gst,
                timestamp: new Date(),
              });
              alert('GST calculation saved!');
            } catch (e) {
              console.error('Error saving document: ', e);
              alert('Error saving calculation.');
            }
          }} className="ms-2">
            Save Calculation
          </Button>
        )}
      </Form>
      {gst !== null && (
        <Alert variant="success" className="mt-4">
          <h5>GST Amount: {gst.toFixed(2)}</h5>
          <h5>Total Amount: {(Number(amount) + gst).toFixed(2)}</h5>
        </Alert>
      )}
    </div>
  );
};

export default GstCalculator;
